import api from '@/api';

class Order {
  static store(order) {
    return api.post('/order', order);
  }
}

export default Order;
